import {
  LuCalendar, LuChartColumn, LuChartLine, LuChartPie, LuCirclePlus, LuDownload, LuFolderTree,
  LuLayers, LuLayoutGrid, LuListFilter, LuSlidersHorizontal, LuTicket, LuTimer, LuUsers,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('helpdesk', '/tickets', 'helpdesk', [
    ['tabs', 'helpdesk.tabs', LuLayers],
    ['filters', 'helpdesk.filters', LuSlidersHorizontal, opt],
    ['views', 'helpdesk.views', LuLayoutGrid, opt],
    ['create', 'helpdesk.create', LuTicket, opt],
  ]),
  tour('helpdesk_dashboard', '/tickets/dashboard', 'helpdesk', [
    ['kpis', 'helpdesk_dashboard.kpis', LuChartColumn],
    ['period', 'helpdesk_dashboard.period', LuCalendar, opt],
    ['charts', 'helpdesk_dashboard.charts', LuChartPie, { placement: 'top', ...opt }],
  ]),
  tour('helpdesk_reports', '/tickets/reports', 'helpdesk', [
    ['trend', 'helpdesk_reports.trend', LuChartLine],
    ['filters', 'helpdesk_reports.filters', LuListFilter, opt],
    ['export', 'helpdesk_reports.export', LuDownload, opt],
  ]),
  // Configuration ▾ menu: SLA, Category, Team.
  tour('helpdesk_sla', '/sla/list', 'helpdesk', [
    ['create', 'helpdesk_sla.create', LuTimer],
    ['filters', 'helpdesk_sla.filters', LuListFilter, opt],
    ['list', 'helpdesk_sla.list', LuLayers, { placement: 'top', ...opt }],
  ]),
  tour('helpdesk_categories', '/category/list', 'helpdesk', [
    ['create', 'helpdesk_categories.create', LuCirclePlus],
    ['filters', 'helpdesk_categories.filters', LuListFilter, opt],
    ['list', 'helpdesk_categories.list', LuFolderTree, { placement: 'top', ...opt }],
  ]),
  tour('helpdesk_teams', '/team/list', 'helpdesk', [
    ['create', 'helpdesk_teams.create', LuCirclePlus],
    ['filters', 'helpdesk_teams.filters', LuListFilter, opt],
    ['list', 'helpdesk_teams.list', LuUsers, { placement: 'top', ...opt }],
  ]),
];

export default tours;
